import React from "react";
import Select from 'react-select';
import Form from '../form/Form';
import { connect } from 'react-redux';

class Calculations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
      selectedCalculationConfig: null,
      selectedProj: null
    };
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption })
    this.setState({ selectedCalculationConfig: this.filterConfig(selectedOption.value) })
  };

  getOptionsFromConfig = (config) => config.map((calculationObj) => { return { value: calculationObj.form_id, label: calculationObj.form_alias } })

  filterConfig = (selectedOption) => {
    let config = this.props.config.find(configObj => configObj.form_id === selectedOption);
    return config;
  }

    static getDerivedStateFromProps(nextProps, prevState) {
      let { formInputValues, config, selectedProject } = nextProps
      let configCopy = Array.from(config)

      let content = configCopy.map((config) => {
        if (formInputValues.length > 0) {
          let formData = formInputValues.find(object => object.category === config.form_id)
          config.data_from_db = formData ? formData : []
        } else {
          config.data_from_db = []
        }
        config.project_id = selectedProject.projectid
        return config
      })

    if (nextProps.selectedProject !== prevState.selectedProj) {
      return { 
        selectedProj: nextProps.selectedProject,
        selectedOption: null,
        data: content
      }
    } else {
      return {
        data: content
      }
    }
  }

  render() {
    const { selectedOption, selectedCalculationConfig, data } = this.state;
    let options = this.getOptionsFromConfig(this.props.config)
    let content = data && selectedOption ? data.find(obj => obj.form_id === selectedOption.value): '';
    let formContent = JSON.parse(JSON.stringify(content));
    
    return (
      <>
        <fieldset id='calculationsSelector' className="calculation-form pb-0">
          <div className="mb-3">
            <Select
              classNamePrefix={'typeahead-select'}
              value={selectedOption}
              onChange={this.handleChange}
              options={options}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              placeholder='Select calculation'
            />
          </div>
          {
            selectedCalculationConfig && selectedOption &&
            <Form
              formTitle={selectedCalculationConfig.form_alias}
              content={formContent}
              isCalculationForm={true}
              key={selectedCalculationConfig.form_alias + '-1'}
          />
          }
        </fieldset>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedProject: state.getSelectedProjectReducer.data,
  config: state.requestCalculationsConfig.data,
  formInputValues: state.postCalculations.data
})

export default connect(mapStateToProps)(Calculations)
